/* eslint-disable */
const pre = '/setting/';

export default {
    path: '/setting',
    title: '系统管理',
    header: 'home',
    custom: 'i-icon-demo i-icon-demo-setting',
    children: [
        // {
        //   path: `${pre}customer-tag`,
        //   title: '客户标签',
        //   auth: ['admin', '客户经理', '客户经理主管'],
        // },
        {
            path: `${pre}rule`,
            title: '规则设置',
        },
        {
            path: `${pre}staff`,
            title: '员工管理',
        },
        {
            path: `${pre}dept`,
            title: '部门管理',
        },
        {
            path: `${pre}role`,
            title: '权限管理',
            auth: ['admin'],
        },
        {
            path: `${pre}notify`,
            title: '通知设置',
        },
        // {
        //   path: `${pre}log`,
        //   title: '系统日志',
        // },
        // {
        //   path: `${pre}template`,
        //   title: '模板管理',
        // },
        // {
        //   path: `${pre}dict`,
        //   title: '资质字典',
        //   auth: ['admin', '客户经理主管', '审核人员']
        // },
        // {
        //   path: `${pre}account`,
        //   title: '系统设置',
        //   auth: ['admin']
        // }
    ],
};
